import { render, staticRenderFns } from "./KgjtWebsiteAnnouncement.vue?vue&type=template&id=adeb16bc&scoped=true&"
import script from "./KgjtWebsiteAnnouncement.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteAnnouncement.vue?vue&type=style&index=0&id=adeb16bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adeb16bc",
  null
  
)

export default component.exports